import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'antd'

import styles from './styles.css'

const { Option } = Select

const selectStyles = {
  width: '90%',
  marginTop: '10px',
}

const SpecificLocations = ({ locations, onChange, selected }) => {
  const locationOptions = locations.map((location) => {
    const { id, name } = location
    return <Option key={id}>{name}</Option>
  })

  return (
    <div className={styles.specificLocationsContainer}>
      <span>
        The default behavior of the widget is to display all active locations.
        To display only a subset of locations, indicate from the dropdown which
        locations should be shown:
      </span>
      <Select
        mode="multiple"
        placeholder="Choose Locations"
        style={selectStyles}
        value={selected}
        onChange={onChange}
      >
        {locationOptions}
      </Select>
    </div>
  )
}

SpecificLocations.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default SpecificLocations



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/SpecificLocations.js